import React from "react";
import PropTypes from "prop-types";

export default class ToolbarButton extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["icon", "label"]).isRequired,
    icon: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    mobileDisplay: PropTypes.bool,
    style: PropTypes.object,
    onClick: PropTypes.func,
  };

  render() {
    let {
      label,
      type,
      disabled,
      icon,
      style,
      mobileDisplay,
      className,
      active,
    } = this.props;

    return (
      <button
        aria-label={label}
        title={label}
        {...(disabled && disabled != "" && { disabled: disabled })}
        type="button"
        role="button"
        className={`toolbar-button notprintable ${
          !mobileDisplay && "hidemobile"
        } ${active && "active"} ${className && className}`}
        onClick={!disabled && this.props.onClick}
        style={style}
      >
        {type === "icon" && (
          <i className={icon} aria-hidden="true" title={label} />
        )}
        {type === "icon" && <span className="sr-only">{label}</span>}
        {type === "label" && label}
      </button>
    );
  }
}

ToolbarButton.defaultProps = {
  type: "icon",
  label: "",
  active: false,
  disabled: false,
  mobileDisplay: true,
  icon: "",
  style: {},
  onClick: () => {},
};
